import { createMuiTheme } from '@material-ui/core/styles';
// A custom theme for this app
const theme = createMuiTheme({
  palette: {
    $white: '#f9f9f9',
    $sea: '#319988',
    $greyishBrown: '#484848',
    $clearBlue: '#2979ff',
    $veryLightPink: '#d9d9d9',
    $tiffanyBlue: '#79e0d6',
    $pale: '#fff2cf',
    $lightMustard: '#f6c468',
    $paleOrange: '#f4af62',
    $orangeyRed: '#ef473a',
    $salmon: '#fc7875',
    $lipstick: '#cb2d3e',
    $dustyBlue: '#5b85ae',
    $paleGrey: '#fafcfc',
    $lightPeriwinkle: ' #cae1ff',
    $softBlue: '#61a7db',
    $iceBlue: '#ebeff1',
    $paleCyan: '#baf4f2',
    $lightGreyBlue: '#b2bec4',
    $coolGrey: '#94a4ad',
    $blueGrey: '#7c909b',
    $oxfordGrey: '#6e8591',
    $battleshipGrey: '#667c88',
    $slateGrey: '#566b76',
    $gunmetal: '#495a63',
    $lightBlueGrey: '#d1d8db',
    $charcoalGrey: '#39474e',
    $lightGreyWhite: '#f7f8f9',
    $lightWhite: '#ffffff',
    $greenIcon: '#009c88',
    $inputColor: '#575d65',
    $title: '#363B40',
    $description: '#777E87',

    // alternative
    $dustyBlueAlt: '#4c739a',
    $paleOrangeAlt: '#f09328',
    $seaAlt: '#2c8778',
    $linkHover: '#4e78c0',
    $dark100: '#363b40',
    $dark50: '#575d65',
    $gray1: '#f2f2f2',
    $lineBG: '#e2e7ec',
    $lightTextGray: '#777e87',
    $ash10: '#f7f8f9',
    $ash60: '#567180',
    $ash100: '#3d525d',
    $lineGrey: '#b1b8c5',
    $uploadBorder: '#97a1ae',
    $uploadBorderHover: '#005efd',
    $uploadBG: '#f7f9fa',
    $errorRed: '#ed5347',
    $sparkOrange: '#fff3e7',
  },
  typography: {
    fontFamily: '\'OpenSans\', sans-serif', // specifying a new font
    $fzH1: '32px',
    $fzH2: '24px',
    $fzH3: '20px',
    $fzH4: '18px',
    $fzH5: '16px',
    $fzH6: '14px',
    $fzDes: '12px',
    $fzBody: '18px',
    
    // line heights
    $lhH2: '32px',
    $lhH3: '30px',
    $lhH4: '28px',
    $lhH5: '24px',
    $lhH6: '20px',
    $lhDes: '16px',
    $lhBody: '24px',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 993,
      lg: 1440,
      xl: 1536,
    },
  },
});

export default theme;